import { render, staticRenderFns } from "./vigor.vue?vue&type=template&id=9f54889a&"
import script from "./vigor.vue?vue&type=script&lang=js&"
export * from "./vigor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports